export enum TimeType {
  HOUR = 'hour',
  DAYTIME = 'daytime',
}
